<template>
  <div id="view">
    <el-config-provider :locale="i18nLocale" :size="assemblySize">
      <RouterView />
    </el-config-provider>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { RouterView } from 'vue-router'
import { GlobalStore } from '@/store/modules/global'
import { storeToRefs } from 'pinia'
// 配置element中英文
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'
import es from 'element-plus/es/locale/lang/es'
import ptBr from 'element-plus/es/locale/lang/pt-br'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/en'
import 'dayjs/locale/es'
import 'dayjs/locale/pt-br'
import dayjs from 'dayjs'
import platformManager from './service/PlatformManager'
// 使用主题
// import { useTheme } from '@/hooks/useTheme'
// useTheme()

const globalStore = GlobalStore()
const { assemblySize, language } = storeToRefs(globalStore)
// element 语言配置
const i18nLocale = computed(() => {
  if (language.value === 'zh') {
    dayjs.locale('zh-cn')
    return zhCn
  }
  if (language.value === 'es') {
    dayjs.locale('es')
    return es
  }
  if (language.value === 'pt') {
    dayjs.locale('pt-br')
    return ptBr
  }
  dayjs.locale('en')
  return en
})

platformManager.initialize()
</script>

<style scoped>
#view {
  width: 100%;
  height: 100%;
}
</style>
